<div class="technical-support-container">
  <!-- Header with View Toggle -->
  <div class="header-section">
    <div class="header-content">
      <h1 class="page-title">
        <mat-icon>support_agent</mat-icon>
        Technical Support
      </h1>
      <div class="header-actions">
        <button mat-raised-button color="primary" *ngIf="viewMode === 'list'" (click)="showCreateForm()">
          <mat-icon>add</mat-icon>
          Create New Ticket
        </button>
        <button mat-raised-button *ngIf="viewMode === 'create'" (click)="showList()">
          <mat-icon>list</mat-icon>
          View All Tickets
        </button>
      </div>
    </div>
  </div>

  <!-- Statistics Cards (Show only in list view) -->
  <div class="stats-section" *ngIf="viewMode === 'list' && stats">
    <div class="stats-grid">
      <mat-card class="stat-card total">
        <mat-card-content>
          <div class="stat-icon"><mat-icon>confirmation_number</mat-icon></div>
          <div class="stat-details">
            <h3>Total Tickets</h3>
            <p class="stat-value">{{ stats.total_tickets }}</p>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card open">
        <mat-card-content>
          <div class="stat-icon"><mat-icon>lock_open</mat-icon></div>
          <div class="stat-details">
            <h3>Open</h3>
            <p class="stat-value">{{ stats.open_tickets }}</p>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card progress">
        <mat-card-content>
          <div class="stat-icon"><mat-icon>autorenew</mat-icon></div>
          <div class="stat-details">
            <h3>In Progress</h3>
            <p class="stat-value">{{ stats.in_progress_tickets }}</p>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card resolved">
        <mat-card-content>
          <div class="stat-icon"><mat-icon>check_circle</mat-icon></div>
          <div class="stat-details">
            <h3>Resolved</h3>
            <p class="stat-value">{{ stats.resolved_tickets }}</p>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card urgent">
        <mat-card-content>
          <div class="stat-icon"><mat-icon>priority_high</mat-icon></div>
          <div class="stat-details">
            <h3>Urgent</h3>
            <p class="stat-value">{{ stats.urgent_tickets }}</p>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card bugs">
        <mat-card-content>
          <div class="stat-icon"><mat-icon>bug_report</mat-icon></div>
          <div class="stat-details">
            <h3>Bug Reports</h3>
            <p class="stat-value">{{ stats.bug_reports }}</p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Ticket List View -->
  <div class="list-container" *ngIf="viewMode === 'list'">
    <mat-card class="filter-card">
      <mat-card-content>
        <!-- Search and Filters -->
        <div class="filters-section">
          <mat-label>Search</mat-label>
          <mat-form-field appearance="outline" class="search-field">
            <input matInput placeholder="Search by name, email, or details" 
                   (input)="onSearchChange($event)">
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>

          <mat-label>Ticket Type</mat-label>
          
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="filters.ticket_type" (selectionChange)="applyFilters()">
              <mat-option [value]="undefined">All Types</mat-option>
              <mat-option *ngFor="let type of ticketTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-label>Priority</mat-label>
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="filters.priority" (selectionChange)="applyFilters()">
              <mat-option [value]="undefined">All Priorities</mat-option>
              <mat-option *ngFor="let priority of priorities" [value]="priority">{{ priority }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-label>Status</mat-label>
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="filters.status" (selectionChange)="applyFilters()">
              <mat-option [value]="undefined">All Statuses</mat-option>
              <mat-option *ngFor="let status of statuses" [value]="status">{{ getStatusText(status) }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-stroked-button color="primary" (click)="clearFilters()">
            <mat-icon>clear</mat-icon>
            Clear Filters
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Tickets Table -->
    <mat-card class="table-card">
      <mat-card-content>
        <div class="table-container">
          <table mat-table [dataSource]="filteredTickets" class="tickets-table">

            <!-- Ticket Number Column -->
            <ng-container matColumnDef="ticket_number">
              <th mat-header-cell *matHeaderCellDef>Ticket #</th>
              <td mat-cell *matCellDef="let ticket">
                <span class="ticket-number">{{ ticket.ticket_number }}</span>
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let ticket">
                <div class="user-info">
                  <span class="user-name">{{ ticket.first_name }} {{ ticket.last_name }}</span>
                </div>
              </td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let ticket">{{ ticket.email }}</td>
            </ng-container>

            <!-- Ticket Type Column -->
            <ng-container matColumnDef="ticket_type">
              <th mat-header-cell *matHeaderCellDef>Type</th>
              <td mat-cell *matCellDef="let ticket">
                <span class="badge badge-type" [style.background-color]="getTicketTypeColor(ticket.ticket_type)">
                  <mat-icon class="badge-icon">
                    {{ ticket.ticket_type === 'Bug' ? 'bug_report' : 
                       ticket.ticket_type === 'Feature Request' ? 'lightbulb' : 'comment' }}
                  </mat-icon>
                  {{ ticket.ticket_type }}
                </span>
              </td>
            </ng-container>

            <!-- Priority Column -->
            <ng-container matColumnDef="priority">
              <th mat-header-cell *matHeaderCellDef>Priority</th>
              <td mat-cell *matCellDef="let ticket">
                <span class="badge badge-priority" [style.background-color]="getPriorityColor(ticket.priority)">
                  {{ ticket.priority }}
                </span>
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let ticket">
                <mat-form-field appearance="outline" class="status-select">
                  <mat-select [(ngModel)]="ticket.status" 
                              (selectionChange)="updateTicketStatus(ticket, $event.value)"
                              [style.color]="getStatusColor(ticket.status)">
                    <mat-option *ngFor="let status of statuses" [value]="status">
                      {{ getStatusText(status) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>

            <!-- Created At Column -->
            <ng-container matColumnDef="created_at">
              <th mat-header-cell *matHeaderCellDef>Created</th>
              <td mat-cell *matCellDef="let ticket">
                <div class="date-info">
                  <span class="date-full">{{ formatDate(ticket.created_at) }}</span>
                  <span class="date-relative">{{ getTimeAgo(ticket.created_at) }}</span>
                </div>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let ticket">
                <div class="action-buttons">
                  <button mat-icon-button color="primary" (click)="viewTicket(ticket)" 
                          matTooltip="View Details">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button mat-icon-button color="accent" (click)="editTicket(ticket)" 
                          matTooltip="Edit Ticket">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" (click)="deleteTicket(ticket)" 
                          matTooltip="Delete Ticket">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="ticket-row"></tr>
          </table>

          <!-- No Data Message -->
          <div class="no-data" *ngIf="filteredTickets.length === 0 && !loading">
            <mat-icon>inbox</mat-icon>
            <p>No tickets found</p>
            <button mat-raised-button color="primary" (click)="showCreateForm()">
              Create Your First Ticket
            </button>
          </div>

          <!-- Loading Spinner -->
          <div class="loading-spinner" *ngIf="loading">
            <mat-spinner diameter="50"></mat-spinner>
            <p>Loading tickets...</p>
          </div>
        </div>

        <!-- Pagination -->
        <mat-paginator [length]="totalRecords"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       [pageIndex]="currentPage - 1"
                       (page)="onPageChange($event)"
                       *ngIf="filteredTickets.length > 0">
        </mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Create/Edit Form View -->
  <div class="form-container" *ngIf="viewMode === 'create'">
    <div class="loading-overlay" *ngIf="loading">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ editMode ? 'Updating ticket...' : 'Submitting your request...' }}</p>
    </div>

    <form [formGroup]="ticketForm" (ngSubmit)="onSubmit()" class="technical-support-form">
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon class="title-icon">{{ editMode ? 'edit' : 'support_agent' }}</mat-icon>
            {{ editMode ? 'Edit Technical Support Ticket' : 'Create Technical Support Request' }}
          </mat-card-title>
          <mat-card-subtitle>
            {{ editMode ? 'Update the ticket information below' : 'Please provide detailed information about your technical issue or request' }}
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          <!-- Personal Information -->
          <div class="form-section">
            <h3 class="section-title">Personal Information</h3>
            <div class="form-row">
              <div class="half-width">
                  <mat-label>First Name *</mat-label>

                <mat-form-field appearance="outline">
                  <input matInput formControlName="first_name" placeholder="Enter your first name">
                  <mat-error *ngIf="firstName?.hasError('required')">First name is required</mat-error>
                  <mat-error *ngIf="firstName?.hasError('minlength')">First name must be at least 2 characters</mat-error>
                </mat-form-field>
              </div>
              <div class="half-width">
                  <mat-label>Last Name *</mat-label>

                <mat-form-field appearance="outline">
                  <input matInput formControlName="last_name" placeholder="Enter your last name">
                  <mat-error *ngIf="lastName?.hasError('required')">Last name is required</mat-error>
                  <mat-error *ngIf="lastName?.hasError('minlength')">Last name must be at least 2 characters</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="full-width">
                <mat-label>Email Address *</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="email" type="email" placeholder="Enter your email address">
                <mat-error *ngIf="email?.hasError('required')">Email is required</mat-error>
                <mat-error *ngIf="email?.hasError('email')">Please enter a valid email address</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Ticket Information -->
          <div class="form-section">
            <h3 class="section-title">Ticket Information</h3>
            <div class="form-row">
              <div class="half-width">
                <mat-label class="field-label">Ticket Type *</mat-label>
                <mat-radio-group formControlName="ticket_type" class="radio-group">
                  <mat-radio-button value="Feature Request" class="radio-button">
                    <mat-icon class="radio-icon">lightbulb</mat-icon>
                    Feature Request
                  </mat-radio-button>
                  <mat-radio-button value="Bug" class="radio-button">
                    <mat-icon class="radio-icon">bug_report</mat-icon>
                    Bug Report
                  </mat-radio-button>
                  <mat-radio-button value="Comment" class="radio-button">
                    <mat-icon class="radio-icon">comment</mat-icon>
                    Comment
                  </mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="ticketType?.hasError('required')" class="radio-error">Ticket type is required</mat-error>
              </div>
              <div class="half-width">
                <mat-label class="field-label">Priority *</mat-label>
                <mat-radio-group formControlName="priority" class="radio-group">
                  <mat-radio-button value="Urgent" class="radio-button urgent">
                    <mat-icon class="radio-icon">priority_high</mat-icon>
                    Urgent
                  </mat-radio-button>
                  <mat-radio-button value="Good to Do" class="radio-button good">
                    <mat-icon class="radio-icon">schedule</mat-icon>
                    Good to Do
                  </mat-radio-button>
                  <mat-radio-button value="Low Importance" class="radio-button low">
                    <mat-icon class="radio-icon">low_priority</mat-icon>
                    Low Importance
                  </mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="priority?.hasError('required')" class="radio-error">Priority is required</mat-error>
              </div>
            </div>
          </div>

          <!-- System Information -->
          <div class="form-section">
            <h3 class="section-title">System Information</h3>
            <div class="form-row">
              <div class="half-width">
                  <mat-label>Browser *</mat-label>

                <mat-form-field appearance="outline">
                  <mat-select formControlName="browser">
                    <mat-option value="">Select Browser</mat-option>
                    <mat-option *ngFor="let browser of browsers" [value]="browser">{{ browser }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="browser?.hasError('required')">Browser is required</mat-error>
                </mat-form-field>
              </div>
              <div class="half-width">
                  <mat-label>Browser Version *</mat-label>

                <mat-form-field appearance="outline">
                  <input matInput formControlName="browser_version" placeholder="e.g., 120.0.6099.109">
                  <mat-error *ngIf="browserVersion?.hasError('required')">Browser version is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <div class="half-width">
                  <mat-label>Operating System *</mat-label>

                <mat-form-field appearance="outline">
                  <mat-select formControlName="os">
                    <mat-option value="">Select OS</mat-option>
                    <mat-option *ngFor="let os of osList" [value]="os">{{ os }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="os?.hasError('required')">Operating system is required</mat-error>
                </mat-form-field>
              </div>
              <div class="half-width">
                  <mat-label>OS Version *</mat-label>

                <mat-form-field appearance="outline">
                  <input matInput formControlName="os_version" placeholder="e.g., Windows 11, macOS 14.0">
                  <mat-error *ngIf="osVersion?.hasError('required')">OS version is required</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Issue Details -->
          <div class="form-section">
            <h3 class="section-title">Issue Details</h3>
            <div class="full-width">
                <mat-label>Additional Details *</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="additional_details" rows="6" 
                          placeholder="Please describe your issue or request in detail. Include steps to reproduce, expected behavior, and actual behavior."></textarea>
                <mat-error *ngIf="additionalDetails?.hasError('required')">Additional details are required</mat-error>
                <mat-error *ngIf="additionalDetails?.hasError('minlength')">Details must be at least 10 characters</mat-error>
                <mat-hint>Minimum 10 characters</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <!-- File Upload (only for new tickets) -->
          <div class="form-section" *ngIf="!editMode">
            <h3 class="section-title">Attachments (Optional)</h3>
            <div class="file-upload-section">
              <mat-label class="field-label">Screenshot or Supporting File</mat-label>
              <div class="file-input-container">
                <input type="file" (change)="onFileChange($event)" accept="image/*,.pdf,.doc,.docx" 
                       class="file-input" id="fileInput">
                <label for="fileInput" class="file-input-label">
                  <mat-icon>cloud_upload</mat-icon>
                  <span>Choose File</span>
                </label>
              </div>
              <div class="file-info">
                <small>Supported formats: Images (JPG, PNG, GIF), PDF, Documents (DOC, DOCX)</small>
                <small>Maximum file size: 5MB</small>
              </div>
              
              <!-- File Preview -->
              <div class="file-preview" *ngIf="screenshotPreview">
                <div class="preview-header">
                  <span class="file-name">{{ screenshotFile?.name }}</span>
                  <button mat-icon-button (click)="removeFile()" class="remove-file-btn" type="button">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="preview-content">
                  <img *ngIf="screenshotFile?.type.startsWith('image/')" 
                       [src]="screenshotPreview" alt="File Preview" class="image-preview">
                  <div *ngIf="!screenshotFile?.type.startsWith('image/')" class="file-preview-placeholder">
                    <mat-icon>description</mat-icon>
                    <span>{{ screenshotFile?.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>

        <mat-card-actions class="form-actions">
          <button mat-raised-button color="primary" type="submit" 
                  [disabled]="ticketForm.invalid || loading" class="submit-btn">
            <mat-icon *ngIf="!loading">{{ editMode ? 'save' : 'send' }}</mat-icon>
            <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
            {{ loading ? (editMode ? 'Updating...' : 'Submitting...') : (editMode ? 'Update Ticket' : 'Submit Request') }}
          </button>
          <button mat-button type="button" (click)="showList()" [disabled]="loading" class="cancel-btn">
            <mat-icon>cancel</mat-icon>
            Cancel
          </button>
          <button mat-button type="button" (click)="resetForm()" [disabled]="loading" class="reset-btn">
            <mat-icon>refresh</mat-icon>
            Reset Form
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
</div>
